import Vue from 'vue'
export default {
	setBeforeData(state,data){  //储存课前预习
		state.beforeData = data;
	},
	setisNext(state,data){  //作业状态
		state.isNext = data
	},
    setSendData(state,data){//发作业所有信息
        state.sendObj = data;
    },
    setTaskId(state,data){//发作业id
        state.taskCatalog = data;
    },
    setTaskQids(state,data){//发作业qid
        state.taskQids = data;
    },
    setTitle(state,title){//发作业qid
        state.title = title;
    },
    setPlayStatus(state,status){//
        state.PlayStatus = status;
    },
    setPlayId(state,id){
        state.audioId = id;
    },
}

